(function () {
    angular
        .module('app')
        .directive('swiper', setswiper);

    setswiper.$inject = ['$timeout', '$window'];
    function setswiper($timeout, $window) {
        return {
            link: function (scope, element, $attrs) {
                let swiper = null;
                return $timeout(function () {
                    let swiperConfig = {};
                    function initializeSwiper() {
                        if ($attrs.swiper.includes("pagination")) {
                            swiperConfig.pagination = {
                                el: ".swiper-pagination",
                                type: "fraction",
                            };
                            if ($attrs.swiper.includes("paginationDinamic")) {
                                swiperConfig.pagination = {
                                    el: ".swiper-pagination",
                                    dynamicBullets: true,
                                };
                            }
                        }

                        if ($attrs.swiper.includes("navigation")) {
                            swiperConfig.navigation = {
                                nextEl: ".swiper-button-next",
                                prevEl: ".swiper-button-prev",
                            };
                        }

                        if ($attrs.swiper.includes("grabCursor")) {
                            swiperConfig.grabCursor = true;
                        }

                        if ($attrs.swiper.includes("slidesPerView")) {
                            swiperConfig.slidesPerView = "auto";
                        }

                        if ($attrs.swiper.includes("spaceBetween")) {
                            swiperConfig.spaceBetween = 24;
                        }
                        if ($attrs.swiper.includes("tablet")) {
                            if($attrs.swiper.includes('1200')) {
                                if ($window.matchMedia("(max-width: 1200px)").matches) {
                                    swiper = new Swiper(element[0], swiperConfig);
                                } else {
                                    swiper = null;
                                }
                            } else {
                                if ($window.matchMedia("(max-width: 979.98px)").matches) {
                                    swiper = new Swiper(element[0], swiperConfig);
                                } else {
                                    swiper = null;
                                }
                            }
                        } else if($attrs.swiper.includes("movil")){
                            if ($window.matchMedia("(max-width: 768px)").matches) {
                                swiper = new Swiper(element[0], swiperConfig);
                            } else {
                                swiper = null;
                            }
                        } else {
                            swiper = new Swiper(element[0], swiperConfig);

                        }
                    }

                    function destroySwiper() {
                        if (swiper) {
                            swiper.destroy(true, true);
                            swiper = null;
                        }
                    }

                    function checkAndInitializeSwiper() {
                        destroySwiper();
                        initializeSwiper();
                    }

                    angular.element($window).on('resize', checkAndInitializeSwiper);

                    $timeout(checkAndInitializeSwiper);

                    scope.$on('$destroy', function () {
                        destroySwiper();
                        angular.element($window).off('resize', checkAndInitializeSwiper);
                    });
                });
            }
        }
    }
})();
